<mat-dialog-content>
  <zwi-login-form (resetPasswordSent)="closeDialog()" (signedIn)="closeDialog()"></zwi-login-form>
</mat-dialog-content>

